import type { ReactNode } from 'react'

import { TonePill, type PillTone as SharedTone } from '../shared/Badge'

/**
 * The Debt trend's and the Executive report's pills, in the one pill style (DEC-193
 * decision 2, replacing DEC-184's solid 700-weight fills). Debt going up is bad here, so
 * "up" takes High's dot and "down" the success dot. Neither is a severity: they colour a
 * direction. `critical` is a count of critical issues (DEC-190), which IS a severity.
 */
export type PillTone = 'bad' | 'good' | 'neutral' | 'critical'

const TONES: Record<PillTone, SharedTone> = {
  bad: 'high',
  good: 'success',
  neutral: 'neutral',
  critical: 'critical',
}

export function Pill({ tone, children, testId }: { tone: PillTone; children: ReactNode; testId?: string }) {
  return (
    <TonePill tone={TONES[tone]} testId={testId}>
      {children}
    </TonePill>
  )
}
